import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation} from "react-i18next";
const MapViewController = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mapViewController" }); 
  const [listViewChecked, setListViewChecked] = useState(true);
  const [mapViewChecked, setMapViewChecked] = useState(false);
  const resourceType = useSelector((state) => state.resourceType);
  const languages = useSelector((state) => state.languages);
  const communities = useSelector((state) => state.communities);
  const accessibility = useSelector((state) => state.accessibility);
  const cost = useSelector((state) => state.cost);
  const [showclear, setShowclear] = useState(false);
  const isPogress = useSelector((index) => index.isPogress);
  useEffect(() => {
    if (
      (resourceType.indexOf("any") === -1 && resourceType.length > 0) ||
      (languages.indexOf("any") === -1 && languages.length > 0) ||
      (communities.indexOf("any") === -1 && communities.length > 0) ||
      (accessibility.indexOf("any") === -1 && accessibility.length > 0) ||
      (cost.indexOf("any") === -1 && cost.length > 0)
    )
      setShowclear(true);
    else setShowclear(false);
  }, [resourceType, languages, communities, accessibility, cost]);
  const listViewChange = () => {
    setMapViewChecked(false);
    setListViewChecked(true);
    props.triggerMapShow(false);
  };
  const mapViewChange = () => {
    setListViewChecked(false);
    setMapViewChecked(true);
    props.triggerMapShow(true);
  };

  const clear_all_filter = () => {
    props.clearAllFilter();
  };

  return (
    <Fragment>
      {!isPogress > 0 && (
        <div className="map-view-controller">
          <div class="form-row justify-content-between">
            <div class="col-auto">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="maplistcontroller"
                  id="res-listview"
                  value="list"
                  checked={listViewChecked}
                  onClick={listViewChange}
                />
                <label
                  class="form-check-label mobile-toggle-list"
                  for="res-listview"
                >
                  <span className="sr-only">{t("list_view")}</span>
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="maplistcontroller"
                  id="res-maptview"
                  value="map"
                  checked={mapViewChecked}
                  onClick={mapViewChange}
                />
                <label
                  class="form-check-label mobile-toggle-map"
                  for="res-maptview"
                >
                  <span className="sr-only">{t("map_view")}</span>
                </label>
              </div>
            </div>
            <div class="col-auto">
              {showclear && (
                <Link onClick={clear_all_filter}>{t("clear_filters")}</Link>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
export default MapViewController;
